export const CLIENT_VIEWS_BASE_PATH = "/client-views";

const STUDIO_SEGMENT = "/studio";

export function isClientViewsPath(pathname = "") {
  return (
    pathname === CLIENT_VIEWS_BASE_PATH ||
    pathname.startsWith(`${CLIENT_VIEWS_BASE_PATH}/`)
  );
}

export function isClientViewsStudioPath(pathname = "") {
  return pathname.includes(`${STUDIO_SEGMENT}`);
}

export function buildClientViewStudioPath(clientViewId, tab) {
  const base = `${CLIENT_VIEWS_BASE_PATH}/${clientViewId}${STUDIO_SEGMENT}`;
  if (tab) {
    return `${base}?tab=${encodeURIComponent(tab)}`;
  }
  return base;
}

export function buildLegacyStudioPath(clientViewId, tab) {
  const base = `/admin/client-views/${clientViewId}${STUDIO_SEGMENT}`;
  if (tab) {
    return `${base}?tab=${encodeURIComponent(tab)}`;
  }
  return base;
}

export function parseClientViewStudioFromPath(pathname = "") {
  const match = pathname.match(
    new RegExp(`^${CLIENT_VIEWS_BASE_PATH.replace(/\//g, "\\/")}/([^/]+)${STUDIO_SEGMENT.replace(/\//g, "\\/")}$`)
  );
  if (!match) {
    return { clientViewId: null, isStudio: false };
  }
  return { clientViewId: match[1], isStudio: true };
}

export function shouldUseClientViewsPerspective(pathname, perspectiveId) {
  return isClientViewsPath(pathname) || perspectiveId === "clientViews";
}
